module.exports = __webpack_public_path__ + "img/categories.9e594b91.png";